import React from 'react';
import { store } from 'store';
import { showGlobalNavigation, hideGlobalNavigation } from 'modules/shell/actions';

/**
 * Hide global navigation component.
 * Use it as React hook on the page where navigation bar is not needed.
 *
 * Use showAgain boolean prop if you need to show Navigation using some condition.
 * @example
 * const MyPage = (props) => {
 *   useHideNavigation();
 *
 *   ... your code here
 *
 *   return (
 *    <div>My Page</div>
 *   );
 * };
 */
export const useHideNavigation = (showAgain = false) => {
  React.useEffect(() => {
    store.dispatch(hideGlobalNavigation());
    if (showAgain) store.dispatch(showGlobalNavigation());
    return () => store.dispatch(showGlobalNavigation());
  }, [showAgain]);
};

export default useHideNavigation;
